module.exports = __webpack_public_path__ + "img/link-banner-pt.2f669a1f.png";